// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1FZHJ","question":"Question_question__21-tO","description":"Question_description__l8pPL"};